export interface DashboardCardConfig {
  id: string;
  permission: string;
  component: string;
  minWidth: "mini" | "medium" | "full";
  order: number;
  enabled: boolean;
  demoOnly?: boolean;
  gridColumn?: string; // retained for backward compatibility
}

export const MASTER_DASHBOARD_CARDS: DashboardCardConfig[] = [
  {
    id: "view_executive_cash_position_card",
    permission: "view_executive_cash_position_card",
    component: "CeoCashPositionCard",
    minWidth: "medium",
    order: 210,
    enabled: true,
  },
  {
    id: "view_current_cash_mini_card",
    permission: "view_current_cash_mini_card",
    component: "CurrentCashMiniCard",
    minWidth: "mini",
    order: 10,
    enabled: true,
  },
  {
    id: "view_30day_forecast_mini_card",
    permission: "view_30day_forecast_mini_card",
    component: "ThirtyDayForecastMiniCard",
    minWidth: "mini",
    order: 20,
    enabled: true,
  },

  {
    id: "view_overdue_invoices_mini_card",
    permission: "view_overdue_invoices_mini_card",
    component: "OverdueInvoicesMiniCard",
    minWidth: "mini",
    order: 30,
    enabled: true,
  },
  {
    id: "view_upcoming_payments_mini_card",
    permission: "view_upcoming_payments_mini_card",
    component: "UpcomingPaymentsMiniCard",
    minWidth: "mini",
    order: 40,
    enabled: true,
  },
  {
    id: "view_variance_card",
    permission: "view_variance_card",
    component: "VarianceCard",
    minWidth: "full",
    order: 50,
    enabled: true,
    demoOnly: true,
  },
  {
    id: "view_uncategorized_items_card",
    permission: "view_uncategorized_items_card",
    component: "UncategorizedItemsCard",
    minWidth: "mini",
    order: 35,
    enabled: true,
  },
  {
    id: "view_upcoming_recurring_transactions_card",
    permission: "view_upcoming_recurring_transactions_card",
    component: "UpcomingRecurringTransactionsCard",
    minWidth: "medium",
    order: 120,
    enabled: true,
  },
  {
    id: "view_actions_card",
    permission: "view_actions_card",
    component: "ActionsCard",
    minWidth: "medium",
    order: 121,
    enabled: true,
  },
  {
    id: "view_bank_accounts_card",
    permission: "view_bank_accounts_card",
    component: "BankAccountsCard",
    minWidth: "full",
    order: 122,
    enabled: true,
  },
  {
    id: "view_critical_alerts_card",
    permission: "view_critical_alerts_card",
    component: "CriticalAlertsCard",
    minWidth: "medium",
    order: 150,
    enabled: false, // R2 — disabled for Release 1
  },
  {
    id: "view_governance_compliance_card",
    permission: "view_governance_compliance_card",
    component: "GovernanceComplianceCard",
    minWidth: "full",
    order: 160,
    enabled: false, // R2 — disabled for Release 1
  },
  {
    id: "view_scenario_comparison_card",
    permission: "view_scenario_comparison_card",
    component: "ScenarioComparisonCard",
    minWidth: "medium",
    order: 170,
    enabled: true,
  },
  {
    id: "view_recent_transactions_card",
    permission: "view_recent_transactions_card",
    component: "RecentTransactionsCard",
    minWidth: "full",
    order: 220,
    enabled: true,
  },
  {
    id: "view_90day_interactive_chart_card",
    permission: "view_90day_interactive_chart_card",
    component: "NinetyDayInteractiveChartCard",
    minWidth: "full",
    order: 230,
    enabled: true,
  },
  {
    id: "view_board_ready_summary_card",
    permission: "view_board_ready_summary_card",
    component: "BoardReadySummaryCard",
    minWidth: "medium",
    order: 140,
    enabled: false, // R2 — disabled for Release 1
  },

  // Duplicate governance card entry removed — view_governance_compliance_card already
  // registered at order: 160 above and enabled: true. Linda picks it up from there.
];

// Cards disabled for Release 1 — derived from registry entries where enabled: false.
export const RELEASE1_DISABLED_CARDS = new Set<string>(
  MASTER_DASHBOARD_CARDS.filter((c) => !c.enabled).map((c) => c.permission),
);
